import LessonCard from '@components/student-dashboard/course-modules/lesson-card'
import { MODULE_STATE } from '@lib/constants/course-modules'
import { ModuleType } from '@lib/types/course-modules'
import classNames from 'classnames'
import { useRef } from 'react'

type Props = {
  showLessons: boolean
  moduleState: ModuleType['state']
  lessons: ModuleType['lessons']
  isOnDashboard: boolean
  isOnCoursePage?: boolean
}
const ModuleAllLessons = ({
  showLessons,
  moduleState,
  lessons,
  isOnDashboard,
  isOnCoursePage,
}: Props) => {
  const lessonsContainerRef = useRef<HTMLDivElement>(null)
  return (
    <div
      className={classNames(
        'flex flex-col transition-all duration-1000 overflow-hidden'
      )}
      style={{
        maxHeight: showLessons
          ? `${lessonsContainerRef.current?.offsetHeight}px`
          : '0',
      }}
    >
      <div ref={lessonsContainerRef}>
        <div className="flex flex-col mt-5">
          {lessons.map((lesson, index) => (
            <LessonCard
              key={index}
              lesson={lesson}
              lessonNumber={index + 1}
              moduleState={moduleState}
              isOnDashboard={isOnDashboard}
              isOnCoursePage={isOnCoursePage}
            />
          ))}
        </div>
        {(moduleState === MODULE_STATE.ONGOING || isOnDashboard) && (
          <p className="border-t border-grey-400 pt-5 text-lg text-orange">
            That’s all the lessons!
          </p>
        )}
      </div>
    </div>
  )
}

export default ModuleAllLessons
